import { LevelSpec } from '../game/LevelSpec';
export default new LevelSpec({
    title: 'Passing Parameters',
    goal: `
		Move <keyword type="robot">Red</keyword> to the <keyword type="goal">Flag</keyword>
		in <b>10 lines or fewer</b>.
	`,
    testGoal: (world) => world.robotsAtGoals().length ? { win: true } : undefined,
    helpText: `
		<p>
			When you call a method, you can <b>pass parameters</b> to it. Parameters are
			extra information you can give to a method to tell it more about what you want
			it to do. Each method has a set of parameters it can accept.
		</p>

		<p>
			For example, <code>walk</code> takes a parameter called <code>steps</code>,
			which tells it how many spaces you would like your Robot to move. e.g.:
		</p>

		<code-block>
			red.walk( steps = 2 )
		</code-block>

		<p>
			The code above is passing parameters <b>by name</b>. That means that each parameter
			has its name followed by an <code>=</code> sign. Python also lets you pass parameters
			<b>by position</b>. That means that Python figures out what the parameters are based on
			their order.
		</p>
		
		<p>
			For example, the following code will do the same thing:
		</p>

		<code-block>
			red.walk( 2 )
		</code-block>

		<p>
			It's up to you whether you prefer to pass parameters by name or by position. However,
			passing parameters by name sometimes makes it easier for others to read and understand
			your code.
		</p>

		<p>
			Try to reach the goal using <b>10 lines or fewer</b>.
		</p>
	`,
    lockedLines: 3,
    maxLines: 10,
    defaultCode: `
		from kitchen import *

		red = robots.get( 'red' )
		
		red.walk( steps = 2 )
		red.turn_left()
	`,
    layout: [
        '...  ',
        '.r. g',
        '... .',
        ' .  .',
        ' ....',
    ],
});
